import { Component, ChangeDetectionStrategy, input, computed, forwardRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Upload, UploadMenuItem } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { UploadType } from '../../../models/upload-type.type';
import { FileDownloaderComponent } from '../../file-downloader/file-downloader.component';
import { FileEditorComponent } from '../../file-editor/file-editor.component';
import { FileUploadButtonComponent } from '../../file-upload-button/file-upload-button.component';

@Component({
  selector: 'xmed-folder',
  standalone: true,
  imports: [
    DatePipe,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    XmedicalUiModule,
    FileDownloaderComponent,
    FileEditorComponent,
    forwardRef(() => FileUploadButtonComponent)
  ],
  templateUrl: './folder.component.html',
  styleUrl: './folder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FolderComponent {
  uploads = input<Upload[]>([]);
  folder = input.required<UploadMenuItem>();
  uploadType = input<UploadType>('practice');
  patientId = input<number | null>(null);
  hasPatientDetails = input(false);

  isLongTitle = computed(() => this.folder().name.length > 20);
  displayName = computed(() => this.folder().name.replace(/\//g, '/\u200B'));
  tags = computed(() => [this.uploadType(), this.folder().path]);

  filteredUploads = computed(() => {
    const type = this.uploadType();
    const path = this.folder().path;
    return this.uploads()
      .filter(upload => {
        const tagNames = upload.tags.map(t => t.tag);
        return tagNames.includes(type) && tagNames.includes(path);
      })
      .sort((a, b) => {
        const dateDiff = new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime();
        if (dateDiff !== 0) return dateDiff;
        return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
      });
  });
}
